import { Container } from "../../styles/CommonStyles";

const MyPage: React.FC = () => {
  return <Container>MyPage</Container>;
};

export default MyPage;
